import { cn } from '@hetivo/hetivo-lib-web-utils';
import { ChevronDown, ChevronRight, Layers, MapPin } from 'lucide-react';
import * as React from 'react';
import { BreadcrumbWrapper } from './breadcrumb-wrapper';
import { HetivoIcon } from './hetivo-icon';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface LocationStateProps {
  interactive?: boolean;
  locationColor?: string;
  locationName: string;
  tenantName: string;
  territoryName?: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function LocationState({
  interactive = true,
  locationColor,
  locationName,
  tenantName,
  territoryName,
}: LocationStateProps): React.JSX.Element {
  return (
    <BreadcrumbWrapper interactive={interactive}>
      <div className="flex items-center gap-0.5">
        <div
          className={cn(
            'flex items-center gap-0.5 overflow-hidden transition-all duration-500 ease-in-out',
            'max-w-0 opacity-0 group-hover/breadcrumb:max-w-[500px] group-hover/breadcrumb:opacity-100',
            interactive && 'group-data-[state=open]/trigger:max-w-[500px] group-data-[state=open]/trigger:opacity-100',
          )}
        >
          <HetivoIcon />
          <span className="text-xs md:text-sm text-muted-foreground whitespace-nowrap truncate max-w-[200px]">
            {tenantName}
          </span>
          <ChevronRight className="size-3.5 mx-0.5 text-muted-foreground/50 shrink-0" />
          {territoryName && (
            <>
              <Layers className="size-3.5 text-muted-foreground" />
              <span className="text-xs md:text-sm text-muted-foreground whitespace-nowrap truncate max-w-[200px]">
                {territoryName}
              </span>
              <ChevronRight className="size-3.5 mx-0.5 text-muted-foreground/50 shrink-0" />
            </>
          )}
        </div>
        <div className="flex items-center gap-1 text-xs md:text-sm font-medium text-foreground">
          <MapPin className="size-3.5" style={{ color: locationColor }} />
          <span className="truncate max-w-[200px]">{locationName}</span>
        </div>
        {interactive && (
          <ChevronDown className="size-3 ms-1 text-muted-foreground/40 group-hover/breadcrumb:text-muted-foreground group-data-[state=open]/trigger:text-muted-foreground transition-colors" />
        )}
      </div>
    </BreadcrumbWrapper>
  );
}
